import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Package, Truck, Database } from 'lucide-react';

// Import the existing page components
import AdminKitsPage from './AdminKitsPage';
import AdminShippingPage from './AdminShippingPage';
import AdminSeedDataPage from './AdminSeedDataPage';

export default function AdminOperationsPage() {
  const [activeTab, setActiveTab] = useState('kits');

  return (
    <div className="space-y-6" data-testid="admin-operations-page">
      <div>
        <h1 className="font-heading text-2xl font-bold">Operations</h1>
        <p className="text-muted-foreground">Manage STEM kits, shipping, and seed data</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-flex">
          <TabsTrigger value="kits" className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            <span className="hidden sm:inline">Products</span>
          </TabsTrigger>
          <TabsTrigger value="shipping" className="flex items-center gap-2">
            <Truck className="h-4 w-4" />
            <span className="hidden sm:inline">Shipping</span>
          </TabsTrigger>
          <TabsTrigger value="seed" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            <span className="hidden sm:inline">Seed Data</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="kits" className="mt-6">
          <AdminKitsPage embedded />
        </TabsContent>
        <TabsContent value="shipping" className="mt-6">
          <AdminShippingPage embedded />
        </TabsContent>
        <TabsContent value="seed" className="mt-6">
          <AdminSeedDataPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
